import { LeagueConfig } from '@leagueplatform/config';
import {
  tenantSpecificConfigs,
  TenantId,
} from '../tenant-configs/tenant-configs.constants';

export const getTenantSpecificConfig = (tenantId: string) => {
  if (tenantId in tenantSpecificConfigs) {
    return tenantSpecificConfigs[tenantId as TenantId] as LeagueConfig;
  }
  return undefined;
};
